import axios from '@/utils/axios'

export async function GetDedications({queryKey}: any) {
  const url = process.env.NEXT_PUBLIC_API_URL + '/dedications/' + queryKey[1]

  const {data} = await axios.get(url)
  return data
}
